import React, { useMemo } from 'react';

import { Scatter } from '@ant-design/plots';

import {
  GRID_STROKE_COLOR,
  GRID_STROKE_SWOT_COLOR,
  SWOT_PERFORMANCE_BETTER_REGION_COLOR,
  SWOT_PERFORMANCE_WORSE_REGION_COLOR,
} from 'constants/charts';

import { SCATTER_DISPLAY_CATEGORY_SCORE_FIELD, SCATTER_DISPLAY_SCORE_FIELD } from './constants';
import { buildScatterTooltipContent, getDisplayScatterData } from './utils';

type Props = {
  data: any;
};

const SCATTER_CHART_HEIGHT = 262;
const ScatterChart = ({ data }: Props) => {
  const displayData = useMemo(() => getDisplayScatterData(data), [data]);

  return (
    <Scatter
      data={displayData}
      appendPadding={20}
      height={SCATTER_CHART_HEIGHT}
      xField={SCATTER_DISPLAY_SCORE_FIELD}
      yField={SCATTER_DISPLAY_CATEGORY_SCORE_FIELD}
      size={5}
      color="blue"
      shape="circle"
      pointStyle={{ fillOpacity: 1 }}
      yAxis={{
        line: {
          style: {
            stroke: ' #aaa',
          },
        },
        label: null,
        title: {
          text: 'Importance to Customer',
        },
      }}
      xAxis={{
        min: 0,
        max: 6,
        tickCount: 8,
        title: {
          text: 'Avg.Market Competition Rating',
        },
        label: {
          autoHide: true,
          autoRotate: false,
        },
        grid: {
          line: {
            style: (text: any, index: any) => {
              if (index == 3) {
                return {
                  stroke: GRID_STROKE_SWOT_COLOR,
                };
              }
              return {
                stroke: GRID_STROKE_COLOR,
              };
            },
          },
        },
        line: {
          style: {
            stroke: '#aaa',
          },
        },
        tickLine: {
          length: 0,
        },
      }}
      annotations={[
        {
          type: 'region',
          start: ['min', 'min'],
          end: [3, 'max'],
          style: {
            fill: SWOT_PERFORMANCE_WORSE_REGION_COLOR,
          },
        },
        {
          type: 'region',
          start: [3, 'min'],
          end: ['max', 'max'],
          style: {
            fill: SWOT_PERFORMANCE_BETTER_REGION_COLOR,
          },
        },
      ]}
      tooltip={{
        customContent: buildScatterTooltipContent,
        domStyles: {
          'g2-tooltip': {
            opacity: 1,
            borderRadius: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            padding: 0,
          },
          'g2-tooltip-list': {
            margin: 0,
          },
        },
      }}
      label={{
        formatter: function (val: any) {
          return val?.categoryName;
        },
      }}
      legend={false}
      style={{ opacity: '1', height: '100%' }}
    />
  );
};

export default ScatterChart;
